import React, { useEffect, useState } from "react";
import socket from "../../assets/socketConnection";
import { socketServer } from "../../assets/socketConnection";
import { Slide } from "react-slideshow-image";
import { AdImage } from "./imageSlider.styles";
const ImageSlider = () => {
  const [adImage, setAdImage] = useState();
  useEffect(() => {
    socket.emit("get_app_ads", { type: "member" });
    socket.on("response_app_ads", (data) => {
      setAdImage(data);
      console.log(data);
    });
  }, []);
  return (
    <div>
      {adImage && (
        <Slide
          duration={1000}
          infinite={true}
          autoplay={true}
          arrows={false}
          canSwipe={true}
        >
          {adImage.map((data, index) => (
            <AdImage
              key={index}
              src={`${socketServer}/uploaded_ads/${data.image}.jpg`}
              onClick={
                data.target !== ""
                  ? () => window.window.open(data.target, "_blank")
                  : console.log("")
              }
              // window.location.href=data.target
              alt="BarnetAd"
            />
          ))}
        </Slide>
      )}
    </div>
  );
};

export default ImageSlider;
